module.exports = __webpack_public_path__ + "static/climate_spanish-ce8cbabbef004ef3e9ae0d91242c7fd4.png";